export const environment = {
  production: true,
  apiUrl: 'https://appjustifacil.minjusticia.gov.co/core',
  intApiUrl: 'https://fn-minjusticia-historial-mjd.azurewebsites.net',
  loadApiUrl: 'https://fn-minjusticia-carga-mjd.azurewebsites.net',
  porcessApiUrl: 'https://fn-minjusticia-procesamiento-mjd.azurewebsites.net',
  pqrs: "https://www.minjusticia.gov.co/atencion-y-servicios-a-la-ciudadania/pqrdsf",
  justinoApiUrl: 'https://appjustifacil.minjusticia.gov.co/adminmas/prod',
  justinoModelUrl: 'https://appjustifacil.minjusticia.gov.co/web/prod',
  justinoWebhookUrl: 'https://appjustifacil.minjusticia.gov.co/webhook/prod',
  downloadApiUrl: 'https://appjustifacil.minjusticia.gov.co/descargas/prod',
  esHttps: true,
  AUTH_FRONT: 'https://adlu.minjusticia.gov.co',
  AUTH_URL: 'https://mishpat.minjusticia.gov.co/',
  ID_ENTITY: '42B25D16-7A2A-4F5C-A693-C714B2965807',
  esLaboratorio: 'false',
  recaptchaSiteKey: '6LeXeScsAAAAAMDIKnKZEdJJxrTeq5-vYw_C-AE5',
  AUTH_LOGOUT_TAB_URL: 'https://adlu.minjusticia.gov.co/auth/logout-tab',
};
